import { Article } from 'data/SingleArticle/types';
import { MiniArticleCardContainer } from 'components/Grids/MiniArticleCards/MiniArticleCardContainer';
import { MiniArticleCards } from 'components/Grids/MiniArticleCards/MiniArticleCards';
import { MiniArticleCardsSkeletons } from 'components/Grids/MiniArticleCards/MiniArticleCardsSkeleton';
import { useParselyMiniArticleCards } from 'hooks/parsely/useParselyMiniArticleCards';

/*
 * The MiniArticleCards on the article page were not being fully re-rendered when a user would navigate to another
 * article, which meant that the hook was not being fired a second time to grab new Parsely & Contentful data. By
 * extracting this component here and wrapping up the hook that gets the data, we're able to force a re-render by
 * changing the key prop where it's consumed based on the current article slug.
 *
 * https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key
 */

export const RelatedArticles = ({
  slugsToDedupe,
  article,
}: {
  slugsToDedupe: string[];
  article: Article;
}) => {
  const {
    loading: loadingMiniArticleCards,
    articles: miniArticleCards,
    error: miniArticleCardsError,
  } = useParselyMiniArticleCards({
    slugsToDedupe: slugsToDedupe.length ? [...slugsToDedupe, article.slug] : [],
    numberOfArticlesToDisplay: 5,
  });

  return (
    <MiniArticleCardContainer headingText="Related articles">
      {loadingMiniArticleCards && !miniArticleCardsError ? (
        <MiniArticleCardsSkeletons />
      ) : (
        <MiniArticleCards
          articles={
            miniArticleCards.length > 0
              ? miniArticleCards
              : article.relatedArticles
          }
          componentNameForTracking="Related articles on article page"
        />
      )}
    </MiniArticleCardContainer>
  );
};
